import * as React from 'react'

const defaultColor = '#9BA3B2'
const activeColor = '#3C52EF'

export default ({ isActive = false }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 14.0713C6.17475 16.2039 7.86743 17.8965 9.99999 18.0713C7.86743 18.246 6.17475 19.9387 6 22.0713C5.82525 19.9387 4.13257 18.246 2.00001 18.0713C4.13257 17.8965 5.82525 16.2039 6 14.0713Z"
      fill={isActive ? activeColor : defaultColor}
    />
    <path
      d="M15 2C15.3089 5.76989 18.3012 8.76216 22.0711 9.07107C18.3012 9.37998 15.3089 12.3723 15 16.1421C14.6911 12.3723 11.6988 9.37998 7.92893 9.07107C11.6988 8.76216 14.6911 5.76989 15 2Z"
      fill={isActive ? activeColor : defaultColor}
    />
  </svg>
)
